import { Search, ChevronDown, Check } from "lucide-react";

export default function ClientsFilters({
  selectedStatus,
  setSelectedStatus,
  showStatusMenu,
  setShowStatusMenu,
  searchTerm,
  setSearchTerm,
  totalCount,
}) {
  const statuses = ["All Clients", "Leads", "Active"];

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
      <div>
        <h2 className="text-lg font-bold text-gray-900">All Clients</h2>
        <p className="text-xs text-gray-500">
          ({totalCount} client{totalCount !== 1 ? "s" : ""})
        </p>
      </div>

      <div className="flex items-center gap-3">
        {/* Status Dropdown */}
        <div className="relative">
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowStatusMenu(!showStatusMenu);
            }}
            className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-lg text-xs font-medium text-gray-700 hover:border-gray-400 transition min-w-[140px] justify-between"
          >
            <span>{selectedStatus}</span>
            <ChevronDown
              className={`w-4 h-4 text-gray-400 transition-transform ${showStatusMenu ? "rotate-180" : ""
                }`}
            />
          </button>

          {showStatusMenu && (
            <div className="absolute right-0 mt-1.5 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-50 py-1.5 animate-in fade-in slide-in-from-top-2 duration-200">
              {statuses.map((status) => (
                <button
                  key={status}
                  onClick={() => {
                    setSelectedStatus(status);
                    setShowStatusMenu(false);
                  }}
                  className="w-full flex items-center justify-between px-3 py-2 text-xs text-gray-700 hover:bg-gray-50 transition"
                >
                  <span
                    className={
                      selectedStatus === status ? "font-semibold text-teal-600" : ""
                    }
                  >
                    {status}
                  </span>
                  {selectedStatus === status && (
                    <Check className="w-3.5 h-3.5 text-teal-600" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Search */}
        <div className="relative flex-1 md:flex-none">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search clients..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-3 py-2 w-full md:w-64 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 text-xs bg-white transition"
          />
        </div>
      </div>
    </div>
  );
}